

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface usertypeParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Usertype {
    id?: string;
    name: string;
    tenantId?: string;
    parameters?: usertypeParameter[];
    links?: any;
}

export abstract class UsertypeData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Usertype[]>;
  abstract create(url: string,data: Usertype): Observable<any>;
  abstract update(url: string,data: Usertype): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract getall(url: string): Observable<any>;
}
